import * as _ from 'lodash';
import { MissionGroup } from "../objects/MissionGroup";

angular.module("tromanWeb").controller('UpdateMissionGroupController', ['$scope', 'tromanServer', 'missions', 'currentMissionGroupId', function ($scope, tromanServer, missions, currentMissionGroupId) {

    const nonvacant = _.reject(missions, x => x.PersonId == null);

    let isSaving = false;
    this.selectedMissionGroup = null;
    this.newList = false;

    this.missionCount = nonvacant.length;
    this.vacantCount = missions.length - nonvacant.length;

    tromanServer.MissionGroups
        .search({})
        .then(data => {
            this.missionGroups = _.orderBy(data, x => x.Name);
            if (currentMissionGroupId) {
                this.missionGroups = _.reject(this.missionGroups, x => x.Id === currentMissionGroupId);
            }
        })
        .catch(x => this.error = x);

    this.canSave = function () {
        if (isSaving) return false;
        if (this.form.$invalid) return false;
        if (nonvacant.length === 0) return false;

        if (this.newList) {
            return this.newListName != null && this.newListName.length > 0;
        } else {
            return this.selectedMissionGroup != null;
        }
    };

    this.save = function () {
        if (!this.canSave()) return;

        if (this.newList) {
            tromanServer.MissionGroups
                .addEntity(new MissionGroup({ Name: this.newListName }))
                .then(rsp => tromanServer.MissionGroups.addToMissionGroup(rsp.result.Id, nonvacant))
                .then(() => { $scope.$close(true); })
                .catch(err => { this.error = err; });

        } else {
            tromanServer.MissionGroups
                .addToMissionGroup(this.selectedMissionGroup, nonvacant)
                .then(() => { $scope.$close(true); })
                .catch(err => { this.error = err; });
        }
    };

    this.cancel = function () {
        $scope.$dismiss("cancelled");
    };
}]);
